var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 28 20",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    height: 20,
    rx: 3,
    width: 28
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0a17a7",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.2824692-1.91644623 1.4911811 2.21076686-9.4483006 6.37223314 6.6746503.0001129v6.66666663l-6.6746503-.0007795 9.4483006 6.3731256-1.4911811 2.2107668-11.9501195-8.0608924.0009836 7.4777795h-6.6666666l-.000317-7.4777795-11.9488189 8.0608924-1.49118107-2.2107668 9.448-6.3731256-6.67434973.0007795v-6.66666663l6.67434973-.0001129-9.448-6.37223314 1.49118107-2.21076686 11.9488189 8.06.000317-7.4768871h6.6666666l-.0009836 7.4768871z",
    fill: "#fff",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#db1f35",
    strokeLinecap: "round",
    strokeWidth: 0.667
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.668 6.332 12.665-8.332",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.013 21.35 11.354-7.652",
    mask: "url(#b)",
    transform: "matrix(1 0 0 -1 0 35.048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.006 6.31-11.843-7.981",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.29 22.31-13.127-8.705",
    mask: "url(#b)",
    transform: "matrix(1 0 0 -1 0 35.915)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 12h12v8h4v-8h12v-4h-12v-8h-4v8h-12z",
    fill: "#e6273e",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagEn);
export default __webpack_public_path__ + "static/media/icon-flag-en.9a67c937df5590b9817e9e99f8965b2a.svg";
export { ForwardRef as ReactComponent };